export const appConfig = {
	favicon: "/resource/favicon.ico",
	logo: "/resource/logo192.png",
	emptyImage: '/resource/empty_content.svg',
	appName: "DS Rentacar",
	logoutURL: '/logout',
	header: {
		showCircle: false,
		showNotifications: false,
		showLang: false,
		showChat: false,

	},
	menu: {
		size: 'mini',
		showAppIcon: false,
		spacing: 0,
		width: {
			desktop: 55
		}
	}
}

export const styles = {
	main: {
		pr: 4
	}
}
